import React from "react";
import AuthPage from "./AuthPage";

export default function RegistrationPage() {
    return <AuthPage mode="registration" />;
}
